<template>
  <div>
    <ToolbarAuth />
    <div class="mb-15">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card class="ma-5" v-if="isAdmin">
            <v-card-title class="primary--text ml-5">Familiestatuut</v-card-title>
            <v-simple-table class="ml-10 mr-10">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td width="60%">Familiestatuut full</td>
                    <td><v-btn small color="accent" class="" @click="goFamFull">GO</v-btn></td>
                  </tr>
                  <tr>
                    <td>Familiestatuut light</td>
                    <td><v-btn small color="accent" class="" @click="goFamLight">GO</v-btn></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card class="ma-5">
            <v-card-title class="primary--text ml-5">Noodopvolging</v-card-title>
            <v-simple-table class="ml-10 mr-10">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td width="60%" class="ml-15">Noodplan BV</td>
                    <td><v-btn small color="accent" class="" @click="goNpBV">GO</v-btn></td>
                  </tr>
                  <tr>
                    <td>Noodplan PH</td>
                    <td><v-btn small color="accent" class="" @click="goNpPH">GO</v-btn></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";

export default {
  name: "Dashboard",
  components: { ToolbarAuth },
  data() {
    return {};
  },
  methods: {
    goFamFull() {
      this.$router.push({ name: "fchartIndex" });
    },
    goFamLight() {
      this.$router.push({ name: "lchartIndex" });
    },
    goNpBV() {
      this.$router.push({ name: "bvIndex" });
    },
    goNpPH() {
      this.$router.push({ name: "phIndex" });
    },
  },
  computed: {},
  created() {},
};
</script>

<style scoped></style>
